import type { Partner } from '@app/generated/api/model'

export function newPartner (): Partner {
  return {
    id: 0,
    name: '',
  }
}
